import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { ApiError } from '@/lib/api/client';
import { useCreateArticle, useKnowledgeTree } from '@/lib/api/knowledge-base';

import { ArticleForm, emptyArticleValues, toArticlePayload } from './article-form';

export function ArticleNewPage({ folderId }: { folderId?: string }) {
  const treeQuery = useKnowledgeTree();
  const createArticle = useCreateArticle();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const folders = treeQuery.data?.folders ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">New article</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          New articles start as a draft — approve when it passes the checklist.
        </p>
      </div>

      {treeQuery.isPending && <p className="text-sm">Loading…</p>}

      {treeQuery.data && (
        <ArticleForm
          initial={emptyArticleValues(folderId ?? '')}
          folders={folders}
          submitting={createArticle.isPending}
          submitLabel="Create draft"
          error={error}
          onCancel={() => void navigate({ to: '/knowledge-base' })}
          onSubmit={(values) => {
            setError(null);
            createArticle.mutate(toArticlePayload(values), {
              onSuccess: (article) =>
                void navigate({
                  to: '/knowledge-base/articles/$articleId/edit',
                  params: { articleId: article.id },
                }),
              onError: (caught) =>
                setError(
                  caught instanceof ApiError ? caught.message : 'Could not create the article.',
                ),
            });
          }}
        />
      )}
    </div>
  );
}
